import { Link } from "react-router-dom";
import useAutoHoverAnimation from '../../hooks/useAutoHoverAnimation';

export default function HeroBanner() {
    const titleRef = useAutoHoverAnimation(100, 100, 600);

    return (
        <>
            <div id="hero">
                <div id="hero-video-background">
                    <img src="/images/courses-banner/course-violin-banner.jpg" alt="Guitar Hero" />
                </div>
                <div id="hero-styles">
                    <div id="hero-caption" className="height-title content-full-width text-align-center parallax-scroll-caption">
                        <div className="inner">
                            <h1 ref={titleRef} className="hero-title caption-timeline primary-font-title">
                                <div>
                                    <span>V</span>
                                    <span>I</span>
                                    <span>O</span>
                                    <span>L</span>
                                    <span>I</span>
                                    <span>N</span>
                                </div>
                            </h1>
                            <div className="hero-cta">
                                <Link to="/admission-form" className="cta-button">ENROLL NOW</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
} 